import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import {
  dashboardMetricsSchema,
  sentimentOverTimeSchema,
  frustrationDriversSchema,
  emergingIssuesSchema,
  conversationMetricsSchema,
  finOpsMetricsSchema,
  analyticsQuerySchema,
} from '../schemas/analytics.schemas';
import { errorResponseSchema } from '../schemas/common.schemas';

const c = initContract();

export const analyticsContract = c.router({
  getDashboardMetrics: {
    method: 'GET',
    path: '/analytics/dashboard',
    query: z.object({
      period: z.enum(['7d', '30d', '90d']).default('30d'),
    }),
    responses: {
      200: dashboardMetricsSchema,
      401: errorResponseSchema,
    },
    summary: 'Get dashboard metrics (FCR, CES, EVI, ROI)',
  },
  getSentimentOverTime: {
    method: 'GET',
    path: '/analytics/sentiment',
    query: analyticsQuerySchema,
    responses: {
      200: sentimentOverTimeSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Get sentiment (EVI) over time',
  },
  getFrustrationDrivers: {
    method: 'GET',
    path: '/analytics/frustration-drivers',
    query: z.object({
      limit: z.coerce.number().int().positive().max(50).default(10),
    }),
    responses: {
      200: frustrationDriversSchema,
      401: errorResponseSchema,
    },
    summary: 'Get top frustration drivers',
  },
  getEmergingIssues: {
    method: 'GET',
    path: '/analytics/emerging-issues',
    query: z.object({
      limit: z.coerce.number().int().positive().max(50).default(10),
    }),
    responses: {
      200: emergingIssuesSchema,
      401: errorResponseSchema,
    },
    summary: 'Get emerging issues trending upward',
  },
  getConversationMetrics: {
    method: 'GET',
    path: '/analytics/conversations/:id/metrics',
    pathParams: z.object({
      id: z.string().uuid(),
    }),
    responses: {
      200: conversationMetricsSchema,
      404: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Get detailed metrics for a specific conversation',
  },
  getFinOpsMetrics: {
    method: 'GET',
    path: '/analytics/finops',
    query: z.object({
      period: z.enum(['7d', '30d', '90d']).default('30d'),
    }),
    responses: {
      200: finOpsMetricsSchema,
      401: errorResponseSchema,
    },
    summary: 'Get FinOps cost tracking metrics',
  },
});
